import { FOOD_REQUEST_KINDS, RECIPE_CONFIDENCES } from '@steado/admin-contract/foods';
import { z } from 'zod';

/**
 * The queue's filters, and the name request open in its drawer, live in the
 * URL: "the open names" and "tawa roti" are links somebody can paste.
 *
 * Opens on the open queue: the design's first screen is what needs a person
 * now. Answered requests are a status away, and each answered one keeps its
 * own page with what its answer wrote.
 */
export const QUEUE_STATUSES = ['open', 'researching', 'resolved', 'rejected'] as const;
export type QueueStatus = (typeof QUEUE_STATUSES)[number];

export const foodRequestsSearchSchema = z.object({
  kind: z.enum(FOOD_REQUEST_KINDS).optional().catch(undefined),
  status: z.enum(QUEUE_STATUSES).optional().catch(undefined),
  confidence: z.enum(RECIPE_CONFIDENCES).optional().catch(undefined),
  q: z.string().trim().min(1).max(80).optional().catch(undefined),
  /** `names`: the name requests ready to approve, selected together. */
  view: z.enum(['names']).optional().catch(undefined),
  /** The name request open in the drawer. */
  open: z.string().uuid().optional().catch(undefined),
});

export type FoodRequestsSearch = z.infer<typeof foodRequestsSearchSchema>;
